import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { sync } from 'vuex-router-sync'

sync(store, router)

router.beforeEach( (to, from, next) => {
    const logged = store.getters.isLogged
    if (!logged && to.meta.requiresAuth === true) {
      next('/login')
    } else if (logged && to.path === '/login'){
      next('/admin-panel')
    } else {
      next()
    }
  })

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {App}
})



// WEBPACK FOOTER //
// ./src/main.js